import { SVGProps } from 'react';

const MetaIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9359 1.14597C12.4749 -0.101634 10.7614 0.698912 10.7614 0.698912C9.63855 1.2099 8.67457 2.59849 8.67457 2.59849C8.67457 2.59849 6.87158 -0.190903 4.26039 0.514115C2.72972 0.92742 1.5621 2.50994 0.958265 4.31081C0.531945 5.58192 0.386475 6.96189 0.592298 8.11602C1.08969 10.9055 3.02233 10.9074 3.92928 10.7319C4.83624 10.5567 5.41968 10.1634 6.20656 9.01445C6.99333 7.86556 8.44398 5.33781 8.44398 5.33781L10.4573 8.49136C11.0329 9.24902 11.4275 9.87277 11.9761 10.2788C12.2239 10.4623 12.5032 10.6013 12.845 10.6881C17.1897 11.7916 17.7958 4.44235 13.9359 1.14597ZM5.03894 7.9814C5.03894 7.9814 3.91596 9.74872 2.81463 8.89697C2.0006 8.26737 2.09945 6.26169 2.62192 4.68441C2.8062 4.12796 3.04314 3.62477 3.3114 3.25415C5.48368 0.253081 7.63026 4.06332 7.63026 4.06332L5.03894 7.9815V7.9814ZM14.1951 8.96079C13.6087 9.32844 13.0699 9.01056 12.6826 8.611C12.3108 8.22735 12.0788 7.76849 12.0788 7.76849L9.46581 3.68008C9.46581 3.68008 10.3553 2.07673 11.4309 1.78491C14.1559 1.04542 16.0197 7.81712 14.1951 8.96089V8.96079Z"
      fill="currentColor"
    />
  </svg>
);

export default MetaIcon;
